import EventEmitter from 'eventemitter3'

const event = new EventEmitter()

export default event


// WEBPACK FOOTER //
// ./src/utils/event.js